import { Datagrid, AutocompleteInput, List, TextField, Edit, Filter,TextInput, DateField, DateInput } from "ra-ui-materialui";
import { useState, useEffect } from "react";
import {
    useRedirect
} from "react-admin";
import { PostBulkActionButtonsPermision } from "./utils";
import { useEditContext } from "ra-core";
import { getScaleStatus } from "../services/master-tables.service";
import { validateCustomDate } from "./utils";
import ScaleForm from "../components/Scale/ScaleForm";


export const ScaleList = props => {

    return (
        <List title={props?.hideTitle ? <span /> : <span>Gestión de Escalas</span>}bulkActionButtons={props?.permissions?.scales?.delete ? <PostBulkActionButtonsPermision perm="scales.delete" /> : false} exporter={false} sort={{ field: 'Id', order: 'DESC' }} filters={<ScaleFilter />} filterDefaultValues={{ clientId: props?.clientId }} {...props}>
            <Datagrid rowClick="edit" isRowSelectable={record => props?.permissions?.scales?.delete}>
                <TextField label="Id" source="id" />
                <TextField label="Escala" source="scaleName" />
                <TextField label="Estado de la Escala" source="scaleStatusName" />
                <DateField label="Fecha de creación" source="createdDate" />                
                <TextField label="Usuario" source="clientName" />
                <TextField label="Profesional" source="professionalName" />
                <TextField label="Área" source="areaName" />
                <TextField label="Contrato" source="contractName" />
                <TextField label="Puntuación" source="totalScore" />
            </Datagrid>
        </List>
    );
}


const ScaleEditContent = () => {
    const { record, basePath } = useEditContext();
    const redirect = useRedirect();
    if (!record) return null;

    return (
        <ScaleForm
            isNew={false}
            data={record}
            isDisabled={record?.scaleStatusName !== "En curso"}
            onCancel={() => redirect('list', basePath)}
        />
    );
};

export const ScaleEdit = (props) => {

    return (
        <Edit title={<ScaleTitle />} mutationMode="pessimistic" {...props} transform={transformScaleEdit}>
            <ScaleEditContent />
        </Edit>
    );
};

const ScaleTitle = ({ record }) => {
    if (!record) return <span />;
    // Los registros de escala tienen clientName/scaleName, no 'name'
    const title = record.scaleName
        ? `Escala: ${record.scaleName} · ${record.clientName || ''}`.trim()
        : (record.clientName ? `Cliente: ${record.clientName}` : '');
    return <span>{title}</span>;
};


const ScaleFilter = (props) => {

    const [scaleStatus, setScaleStatus] = useState();

     useEffect(() => {
             getScaleStatus().then(
                 res => {
                     setScaleStatus(res?.elements);
                 }
             )
         }, []);
         
    return (
        <Filter {...props}>
            <TextInput label="Id" source="id" />
            <TextInput label="Escala" source="scaleName" alwaysOn />
            <TextInput label="Usuario" source="clientName" alwaysOn />
            <TextInput label="Contrato" source="contractName" alwaysOn />
            <TextInput label="Area" source="areaName" alwaysOn />
            
            {
                scaleStatus ?
                    <AutocompleteInput
                        label="Estado"
                        source="scaleStatusId"
                        choices={scaleStatus}
                        optionText="value"
                        optionValue="id"
                        options={{ InputProps: { autoComplete: 'off' } }}
                        resettable={true}
                    />
                    : null
            }
            <TextInput label="Nombre de Profesional" source="professionalName"  />
            <DateInput label="Fecha de Creación" source="createdDate" validate={[validateCustomDate('Error de Formato')]} />

        </Filter>
    );
}


const transformScaleEdit = (data) => {
    //const createTime = data.createTime ? moment(data.createTime).format('yyyy-MM-DDTHH:mm:ss') : null;
    return {
        ...data
    }
}
